import { useAgreementsController } from "./Agreements.controller";
import { AgreementsPresentation } from "./Agreements.pres";

export const Agreements = () => {
  const controllerProps = useAgreementsController();

  return <AgreementsPresentation {...controllerProps} />;
};
